import { t } from 'i18next'

import { Button } from '../components/Button'
import { ModalWrapper } from './ModalWrapper.tsx'
import { getSocialMedia, removeSocialMedia } from '../services/socialMedia.ts'
import { handleError } from '../helpers/handleError.ts'
import { toast } from 'react-toastify'
export const ConfirmDeleteModal = ({
  id,
  onClose,
  showModal,
  setSocialMediaIcons
}: ModalProps) => {
  const confirmDeleteSoicalMedia = async () => {
    try {
      await removeSocialMedia(String(id))
      toast.success(t('socialMediaRemovedSuccessfully'))
      getSocialMedia().then((res) => {
        setSocialMediaIcons(res)
      })
      onClose()
    } catch (e) {
      handleError(e)
    }
  }

  return (
    <ModalWrapper onClose={onClose} showModal={showModal}>
      <div className="flex flex-col p-4">
        <p className="mb-5 text-center text-sm font-medium">
          {t('confirmDelete')}
        </p>

        <div className="flex flex-col gap-5">
          <Button
            text={t('yesRemove')}
            onClick={confirmDeleteSoicalMedia}
            type="submit"
            className="text-white"
          />

          <Button
            text={t('Cancel')}
            onClick={onClose}
            type="button"
            className="border-[1px] border-[#676b5f] bg-transparent shadow-none hover:text-white"
          />
        </div>
      </div>
    </ModalWrapper>
  )
}
